(function () {
  'use strict';

  var SESSION_KEY = 'powersportos_vehicle';

  var YMM = {
    apiUrl: '',
    apiKey: '',
    vehicles: [],
    state: {
      year: null,
      make: null,
      makeId: null,
      model: null,
      modelId: null,
      vehicle: null
    },

    init: function () {
      var config = window.YMM_CONFIG || {};
      this.apiUrl = config.apiUrl || '';
      this.apiKey = config.apiKey || '';

      // Per-product fitment badge — independent of YMM section placement.
      this.checkProductFitment();

      // YMM section interactivity — only runs if section is on this page.
      var widget = document.getElementById('ymm-widget');
      if (!widget) return;

      this.bindElements();
      this.bindEvents();

      var saved = this.getSavedVehicle();
      if (saved) {
        this.showActiveBar(saved.label);
      } else {
        this.loadYears();
      }
    },

    bindElements: function () {
      this.yearEl = document.getElementById('ymm-year');
      this.makeEl = document.getElementById('ymm-make');
      this.modelEl = document.getElementById('ymm-model');
      this.submodelWrapEl = document.getElementById('ymm-submodel-wrap');
      this.submodelEl = document.getElementById('ymm-submodel');
      this.submitEl = document.getElementById('ymm-submit');
      this.activeEl = document.getElementById('ymm-active');
      this.activeLabelEl = document.getElementById('ymm-active-label');
      this.seePartsEl = document.getElementById('ymm-see-parts');
      this.clearEl = document.getElementById('ymm-clear');
      this.loadingEl = document.getElementById('ymm-loading');
      this.errorEl = document.getElementById('ymm-error');
      this.formEl = document.getElementById('ymm-form');
    },

    bindEvents: function () {
      var self = this;
      this.yearEl.addEventListener('change', function () { self.onYearChange(); });
      this.makeEl.addEventListener('change', function () { self.onMakeChange(); });
      this.modelEl.addEventListener('change', function () { self.onModelChange(); });
      this.submodelEl.addEventListener('change', function () { self.onSubmodelChange(); });
      this.submitEl.addEventListener('click', function () { self.findParts(); });
      this.clearEl.addEventListener('click', function () { self.clearVehicle(); });
      if (this.seePartsEl) {
        this.seePartsEl.addEventListener('click', function () { self.goToResults(); });
      }
    },

    goToResults: function () {
      var saved = this.getSavedVehicle();
      if (!saved) return;
      window.location.href = '/pages/ymm-results' +
        '?vehicleId=' + encodeURIComponent(saved.vehicleId) +
        '&vehicle=' + encodeURIComponent(saved.label || '');
    },

    fetch: function (path) {
      // cache: 'no-store' bypasses the browser HTTP cache. The YMM
      // catalog endpoints (years/makes/models/vehicles/parts) mutate
      // as merchants add new vehicles and fitments in the PowersportOS
      // portal — stale browser cache leaves dropdowns missing newly
      // added entries until cache expires. Backend can also set
      // no-cache Cache-Control headers; this is a frontend safeguard
      // either way.
      return fetch(this.apiUrl + path, {
        headers: { 'X-API-Key': this.apiKey },
        cache: 'no-store'
      }).then(function (res) {
        if (!res.ok) throw new Error('API error ' + res.status);
        return res.json();
      });
    },

    loadYears: function () {
      var self = this;
      this.setLoading(true);
      this.fetch('/api/t/years')
        .then(function (years) {
          self.populate(self.yearEl, years.map(function (y) {
            return { value: y, label: y };
          }), 'Year');
          self.yearEl.disabled = false;
        })
        .catch(function () { self.showError('Could not load years. Check API settings.'); })
        .finally(function () { self.setLoading(false); });
    },

    onYearChange: function () {
      var year = this.yearEl.value;
      if (!year) return;

      this.state.year = year;
      this.state.makeId = null;
      this.state.make = null;
      this.state.modelId = null;
      this.state.model = null;
      this.state.vehicle = null;

      this.reset(this.makeEl, 'Make');
      this.reset(this.modelEl, 'Model');
      this.reset(this.submodelEl, 'Variant');
      this.submodelWrapEl.hidden = true;
      this.submitEl.disabled = true;

      var self = this;
      this.setLoading(true);
      this.fetch('/api/t/makes?year=' + year)
        .then(function (makes) {
          self.populate(self.makeEl, makes.map(function (m) {
            return { value: m.id, label: m.name };
          }), 'Make');
          self.makeEl.disabled = false;
        })
        .catch(function () { self.showError('Could not load makes.'); })
        .finally(function () { self.setLoading(false); });
    },

    onMakeChange: function () {
      var makeId = this.makeEl.value;
      var makeName = this.makeEl.options[this.makeEl.selectedIndex].text;
      if (!makeId) return;

      this.state.makeId = makeId;
      this.state.make = makeName;
      this.state.modelId = null;
      this.state.model = null;
      this.state.vehicle = null;

      this.reset(this.modelEl, 'Model');
      this.reset(this.submodelEl, 'Variant');
      this.submodelWrapEl.hidden = true;
      this.submitEl.disabled = true;

      var self = this;
      this.setLoading(true);
      this.fetch('/api/t/models?makeId=' + makeId + '&year=' + this.state.year)
        .then(function (models) {
          if (!models.length) {
            self.showError('No models found for ' + makeName + ' in ' + self.state.year + '.');
            return;
          }
          self.populate(self.modelEl, models.map(function (m) {
            return { value: m.id, label: m.name };
          }), 'Model');
          self.modelEl.disabled = false;
        })
        .catch(function () { self.showError('Could not load models.'); })
        .finally(function () { self.setLoading(false); });
    },

    onModelChange: function () {
      var modelId = this.modelEl.value;
      var modelName = this.modelEl.options[this.modelEl.selectedIndex].text;
      if (!modelId) return;

      this.state.modelId = modelId;
      this.state.model = modelName;
      this.state.vehicle = null;

      this.reset(this.submodelEl, 'Variant');
      this.submodelWrapEl.hidden = true;
      this.submitEl.disabled = true;

      var self = this;
      this.setLoading(true);
      this.fetch('/api/t/vehicles?modelId=' + modelId + '&year=' + this.state.year)
        .then(function (vehicles) {
          self.vehicles = vehicles;
          if (!vehicles.length) {
            self.showError('No vehicle data found for this combination.');
            return;
          }
          var hasSubmodels = vehicles.length > 1 && vehicles.some(function (v) { return v.submodel; });
          if (hasSubmodels) {
            self.populate(self.submodelEl, vehicles.map(function (v) {
              return { value: v.id, label: v.submodel || 'Standard' };
            }), 'Variant');
            self.submodelEl.disabled = false;
            self.submodelWrapEl.hidden = false;
          } else {
            self.state.vehicle = vehicles[0];
            self.submitEl.disabled = false;
          }
        })
        .catch(function () { self.showError('Could not load vehicle data.'); })
        .finally(function () { self.setLoading(false); });
    },

    onSubmodelChange: function () {
      var vehicleId = this.submodelEl.value;
      if (!vehicleId) return;
      this.state.vehicle = this.vehicles.find(function (v) { return v.id === vehicleId; });
      this.submitEl.disabled = false;
    },

    findParts: function () {
      if (!this.state.vehicle) return;

      var label = [
        this.state.year,
        this.state.make,
        this.state.model,
        this.state.vehicle.submodel || ''
      ].filter(Boolean).join(' ');

      // Persist for the result page + fitment badge consumers
      this.saveVehicle({ vehicleId: this.state.vehicle.id, label: label });

      // Redirect to the dedicated result panel. The result page
      // fetches parts from PowersportOS itself, then resolves each
      // partNumber against Shopify's Storefront GraphQL — keeps URLs
      // clean and avoids the storefront search-page UX.
      var url = '/pages/ymm-results' +
                '?vehicleId=' + encodeURIComponent(this.state.vehicle.id) +
                '&vehicle=' + encodeURIComponent(label);
      window.location.href = url;
    },

    clearVehicle: function () {
      sessionStorage.removeItem(SESSION_KEY);

      // If user is on the result page with a vehicle context, dropping
      // the vehicle should take them out — the page would otherwise
      // render whatever the URL params say.
      if (window.location.pathname === '/pages/ymm-results') {
        window.location.href = '/';
        return;
      }

      this.activeEl.hidden = true;
      this.formEl.hidden = false;
      this.state = { year: null, make: null, makeId: null, model: null, modelId: null, vehicle: null };
      this.reset(this.yearEl, 'Year');
      this.reset(this.makeEl, 'Make');
      this.reset(this.modelEl, 'Model');
      this.reset(this.submodelEl, 'Variant');
      this.makeEl.disabled = true;
      this.modelEl.disabled = true;
      this.submodelEl.disabled = true;
      this.submodelWrapEl.hidden = true;
      this.submitEl.disabled = true;
      this.loadYears();
    },

    showActiveBar: function (label) {
      this.formEl.hidden = true;
      this.activeLabelEl.textContent = 'Your vehicle: ' + label;
      this.activeEl.hidden = false;
    },

    checkProductFitment: function () {
      var badgeEl = document.getElementById('product-fitment-badge');
      if (!badgeEl) return;

      var productSku = badgeEl.dataset.productSku;
      if (!productSku) return;

      var saved = this.getSavedVehicle();
      if (!saved) return;

      // Inject CSS once — the YMM section's stylesheet only loads on
      // pages where the section is placed (collections, header, etc.),
      // NOT on product pages where the badge actually renders. Inline
      // CSS makes the badge self-contained.
      this.injectFitmentBadgeCss();

      this.fetch('/api/t/parts?vehicleId=' + saved.vehicleId)
        .then(function (parts) {
          var matchingPart = null;
          parts.forEach(function (p) {
            if (p.partNumber === productSku) matchingPart = p;
          });

          if (matchingPart) {
            var text = '<span class="fitment-badge__icon">✓</span> Fits: ' + saved.label;
            if (matchingPart.oemPartNumber) {
              text += '<span class="fitment-badge__sep">·</span>Replaces OEM: ' + matchingPart.oemPartNumber;
            }
            badgeEl.innerHTML = text;
            badgeEl.classList.add('product-fitment-badge--fits');
          } else {
            badgeEl.innerHTML = '<span class="fitment-badge__icon">✗</span> Does not fit: ' + saved.label;
            badgeEl.classList.add('product-fitment-badge--no-fit');
          }
          badgeEl.hidden = false;
        })
        .catch(function () { /* silent */ });
    },

    injectFitmentBadgeCss: function () {
      if (document.getElementById('ymm-fitment-badge-css')) return;
      var style = document.createElement('style');
      style.id = 'ymm-fitment-badge-css';
      style.textContent =
        '.product-fitment-badge{display:flex;align-items:center;gap:.5rem;padding:.7rem 1rem;border-radius:6px;font-size:.9rem;font-weight:500;line-height:1.4;margin:.5rem 0 1rem;width:100%;box-sizing:border-box}' +
        '.product-fitment-badge--fits{background:#f0fdf4;color:#166534;border:1px solid #bbf7d0}' +
        '.product-fitment-badge--no-fit{background:#fff7ed;color:#9a3412;border:1px solid #fed7aa}' +
        '.fitment-badge__icon{font-weight:700;font-size:1rem;flex-shrink:0}' +
        '.fitment-badge__sep{margin:0 .4rem;opacity:.4;flex-shrink:0}' +
        '@media (max-width:600px){.product-fitment-badge{flex-wrap:wrap;font-size:.85rem;padding:.6rem .85rem}.fitment-badge__sep{display:none;width:100%;height:0;margin:0}}';
      document.head.appendChild(style);
    },

    populate: function (select, options, placeholder) {
      select.innerHTML = '<option value="">' + placeholder + '</option>';
      options.forEach(function (opt) {
        var el = document.createElement('option');
        el.value = opt.value;
        el.textContent = opt.label;
        select.appendChild(el);
      });
    },

    reset: function (select, placeholder) {
      select.innerHTML = '<option value="">' + placeholder + '</option>';
      select.disabled = true;
    },

    setLoading: function (on) {
      if (this.loadingEl) this.loadingEl.hidden = !on;
    },

    showError: function (msg) {
      var self = this;
      if (!this.errorEl) return;
      this.errorEl.textContent = msg;
      this.errorEl.hidden = false;
      setTimeout(function () { self.errorEl.hidden = true; }, 5000);
    },

    saveVehicle: function (data) {
      try { sessionStorage.setItem(SESSION_KEY, JSON.stringify(data)); } catch (e) {}
    },

    getSavedVehicle: function () {
      try { return JSON.parse(sessionStorage.getItem(SESSION_KEY)); } catch (e) { return null; }
    }
  };

  document.addEventListener('DOMContentLoaded', function () { YMM.init(); });
})();
